import { Component } from '@angular/core';


export class SkyNavbarComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-navbar',
  template: `<div class="sky-navbar">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-navbar {
  background-color: #2f4050;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
